import { routeAction } from "app/store/transmission/actions/routeAction";
import { transmissionCountAction } from "app/store/transmission/actions/transmissionCountAction";
import { transmissionModalAction } from "app/store/transmission/actions/transmissionModalAction";

import { transmissionPatientModalAction } from "app/store/transmission/actions/transmissionPatientModalAction";
import { transmissionTableAction } from "app/store/transmission/actions/transmissionTableAction";
import { transmissionTitleAction } from "app/store/transmission/actions/transmissionTitleAction";

import { transmissionToggleAction } from "app/store/transmission/actions/transmissionToggleAction";
import { reportDetailAction } from "app/store/transmission/actions/reportDetailAction";
import { patientNoteAction } from "app/store/transmission/actions/patientNoteAction";

import { reportBillingAction } from "app/store/transmission/actions/reportBillingAction";
import { clinicNoteAction } from "app/store/transmission/actions/clinicNoteAction";

import { transmissionPdfAction } from "app/store/transmission/actions/transmissionPdfAction";
import { transmissionTaskAction } from "app/store/transmission/actions/transmissionTaskAction";
import { previousAlertAction } from "app/store/transmission/actions/previousAlertAction";
import { reportNoteAction } from "./reportNoteAction";
import { insertPageAction } from "./insertPageAction";
import { ehrNoteAction } from "./ehrNoteAction";
import { transmissionInitialState } from "../slice/transmissionSlice";
import { providerNoteAction } from "./providerNoteAction";

export const transmissionAction = {
  setLoading: (state, action) => {
    state.isLoading = action.payload;
  },

  setSelectedTab: (state, action) => {
    state.selectedTab = action.payload;
  },

  setReports: (state, action) => {
    state.reports = action.payload;
  },

  setReportList: (state, action) => {
    state.reportList = action.payload;
  },

  setReportsMeta: (state, action) => {
    state.reportsMeta = action.payload;
  },

  resetTransmissionState: (state, _action) => {
    const { isMyPatientsFilter, ...restInitialState } =
      transmissionInitialState;

    return {
      ...restInitialState,
      route: state.route,
      selectedTab: state.selectedTab,
      isMyPatientsFilter: state.isMyPatientsFilter,
    };
  },

  ...routeAction,
  ...transmissionTitleAction,
  ...transmissionCountAction,
  ...transmissionModalAction,
  ...transmissionPatientModalAction,
  ...transmissionToggleAction,
  ...transmissionTableAction,
  ...reportDetailAction,
  ...patientNoteAction,
  ...reportBillingAction,
  ...clinicNoteAction,
  ...transmissionPdfAction,
  ...transmissionTaskAction,
  ...previousAlertAction,
  ...reportNoteAction,
  ...insertPageAction,
  ...ehrNoteAction,
  ...providerNoteAction,
};
